import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import InputMask from "react-input-mask"
class InputCustom extends Component {
  render() {
    return (
      <div className={this.props.sizeClass}>
        <div className="form-group label-floating">
          <label className="control-label">{this.props.label}</label>
          <InputMask
            onKeyDown={this.props.onKeyDown}
            mask={this.props.mask}
            maskChar=" "
            onChange={this.props.onChange}
            value={this.props.value}
            type={this.props.type}
            className="form-control"
            disabled={this.props.disabled}
            onBlur={this.props.onBlur}
          />
          <span className="label label-danger">{this.props.error}</span>
        </div>
      </div>
    )
  }
}
export default withRouter(InputCustom)



// WEBPACK FOOTER //
// ./src/components/InputMaskCustom.js